import { EditFilled } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Link, useParams } from "react-router-dom";

type Props = {
  page: number;
  pageSize: number;
};

const EditCategoryGeneral = (props: Props) => {
  const { page, pageSize } = props;
  const { id, categoryId } = useParams();

  return (
    <div className="flex flex-col gap-3">
      <Link
        to={`/main-websites/manage-categories/${id}/edit-title/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Title
        </Button>
      </Link>
      <Link
        to={`/main-websites/manage-categories/${id}/edit-description/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Description
        </Button>
      </Link>
      <Link
        to={`/main-websites/manage-categories/${id}/edit-keywords/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Keywords
        </Button>
      </Link>
      <Link
        to={`/main-websites/manage-categories/${id}/edit-image/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Image
        </Button>
      </Link>{" "}
      <Link
        to={`/main-websites/manage-categories/${id}/edit-top-10-articles/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Top 10 Articles
        </Button>
      </Link>{" "}
      <Link
        to={`/main-websites/manage-categories/${id}/manage-rich-text/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Manage Rich Texts
        </Button>
      </Link>{" "}
      <Link
        to={`/main-websites/manage-categories/${id}/sort-items/${categoryId}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Sorted Items
        </Button>
      </Link>
    </div>
  );
};

export default EditCategoryGeneral;
